import { render } from "./captionTable.vue?vue&type=template&id=bde0248c"
import script from "./captionTable.vue?vue&type=script&lang=js"
export * from "./captionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__